import { render, staticRenderFns } from "./OrderSampleButton.vue?vue&type=template&id=1859565a&"
import script from "./OrderSampleButton.vue?vue&type=script&lang=js&"
export * from "./OrderSampleButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports